import React from 'react';
import { ChevronRight } from 'lucide-react';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import NextStepButton from '../../../Components/NextStepButton';
import { StepperNavigationButtons } from '../../../Components/StepperNavigationButtons';
import StepProps from '../../StepProps';
import { useCreateRecruitmentContext } from '../../../Create/Contexts/CreateRecruitmentContext';

function RequestInformationStepNavigation({ activeStep, handleBack }: StepProps): React.JSX.Element {
    const { processingState } = useCreateRecruitmentContext();

    return (
        <StepperNavigationButtons
            activeStep={activeStep}
            handleBack={handleBack}
            nextButtonComponent={
                <NextStepButton
                    loading={processingState === ProcessingState.Processing}
                    endIcon={<ChevronRight className="size-5" aria-hidden />}
                >
                    {UIStrings.Next}
                </NextStepButton>
            }
            processingState={processingState}
        />
    );
}

export default RequestInformationStepNavigation;
